import { Link } from "react-router-dom";
import { useDocumentMeta } from "@/lib/useDocumentMeta";
import { META, STUDIO, absUrl, useNoIndex } from "@/lib/seo";

export default function NotFoundPage() {
  useDocumentMeta({
    title: META.notFound.title,
    description: META.notFound.description,
    url: absUrl(META.notFound.path),
    type: "website",
    siteName: STUDIO.brand,
  });
  useNoIndex();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6">
      <span className="font-mono-display text-[11px] uppercase tracking-[0.32em] text-foreground/60">
        (404)
      </span>
      <h1 className="font-display text-6xl sm:text-8xl leading-[0.95] tracking-tight text-center">
        Not found.
      </h1>
      <p className="text-foreground/70 max-w-md text-center">
        The page you are looking for has been moved or no longer exists. Return home to continue
        browsing the HBS Architecture portfolio.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3 mt-2">
        <Link
          to="/"
          className="inline-flex items-center gap-3 rounded-full bg-foreground text-background px-5 py-3"
        >
          <span className="font-mono-display text-[11px] uppercase tracking-[0.28em]">
            Back to home
          </span>
        </Link>
        <Link
          to="/works"
          className="inline-flex items-center gap-3 rounded-full border border-foreground/30 px-5 py-3 hover:border-foreground/60 transition-colors"
        >
          <span className="font-mono-display text-[11px] uppercase tracking-[0.28em]">
            Browse our works
          </span>
        </Link>
        <Link
          to="/contact"
          className="inline-flex items-center gap-3 rounded-full border border-foreground/30 px-5 py-3 hover:border-foreground/60 transition-colors"
        >
          <span className="font-mono-display text-[11px] uppercase tracking-[0.28em]">
            Contact the studio
          </span>
        </Link>
      </div>
    </div>
  );
}
